import { api } from '../api';

/**
 * As chamadas do diário de campo.
 *
 * Cada caminho vem escrito por inteiro — é o contrato entre a tela e a
 * API, e o teste 26 o procura aqui pelo literal.
 */

export interface Diario {
  id: string;
  os_id: string;
  os_numero: string | null;
  obra_codigo: string | null;
  obra_nome: string | null;
  data: string;
  equipe_id: string | null;
  equipe_codigo: string | null;
  equipe_nome: string | null;
  veiculo_id: string | null;
  veiculo_placa: string | null;
  responsavel_id: string;
  responsavel_nome: string | null;
  clima: string | null;
  temperatura_c: string | null;
  hora_inicio: string | null;
  hora_intervalo_inicio: string | null;
  hora_intervalo_fim: string | null;
  hora_fim: string | null;
  latitude: string | null;
  longitude: string | null;
  ocorrencias: string | null;
  observacoes: string | null;
  situacao: string;
  fechado_por_nome: string | null;
  fechado_em: string | null;
  motivo_cancelamento: string | null;
  horas_trabalhadas: string | null;
  paralisacoes: string;
  pontos_no_dia: string;
  avanco_m: string | null;
  fotos: string;
}

export interface DiarioPonto {
  id: string;
  ponto_id: string;
  ponto_codigo: string;
  ponto_tipo: string;
  profundidade_inicial: string;
  profundidade_final: string;
  avanco_m: string;
  nivel_agua: string | null;
  concluido: boolean;
  observacoes: string | null;
}

export interface Paralisacao {
  id: string;
  inicio: string;
  fim: string | null;
  motivo: string;
  descricao: string | null;
}

/** Onde cada furo da OS parou — para o dia não recomeçar do zero. */
export interface PontoAvanco {
  ponto_id: string;
  codigo: string;
  tipo: string;
  profundidade_prevista: string | null;
  profundidade_fechada: string;
  profundidade_lancada: string;
  dias_fechados: string;
  dias_em_rascunho: string;
  concluido: boolean | null;
}

export interface FichaDoDiario {
  diario: Diario;
  pontos: DiarioPonto[];
  paralisacoes: Paralisacao[];
  fotos: unknown[];
  disponiveis: PontoAvanco[];
}

export const verDiarios = (busca: string) =>
  api<Diario[]>(`/diarios${busca ? `?${busca}` : ''}`);

export const verDiariosDaOs = (osId: string) =>
  api<Diario[]>(`/os/${osId}/diarios`);

export const verDiario = (id: string) =>
  api<FichaDoDiario>(`/diarios/${id}`);

export const criarDiario = (osId: string, corpo: unknown) =>
  api<FichaDoDiario>(`/os/${osId}/diarios`, { metodo: 'POST', corpo });

export const alterarDiario = (id: string, corpo: unknown) =>
  api<FichaDoDiario>(`/diarios/${id}`, { metodo: 'PATCH', corpo });

export const lancarPontoDoDia = (id: string, corpo: unknown) =>
  api<FichaDoDiario>(`/diarios/${id}/pontos`, { metodo: 'POST', corpo });

export const lancarParalisacao = (id: string, corpo: unknown) =>
  api<FichaDoDiario>(`/diarios/${id}/paralisacoes`, { metodo: 'POST', corpo });

/** Fechar é assinar (§10). */
export const fecharDiario = (id: string) =>
  api<FichaDoDiario>(`/diarios/${id}/fechar`, { metodo: 'POST', corpo: {} });

/** Reabrir é retificar — e retificar tem motivo. */
export const reabrirDiario = (id: string, motivo: string) =>
  api<FichaDoDiario>(`/diarios/${id}/reabrir`,
    { metodo: 'POST', corpo: { motivo } });

export const cancelarDiario = (id: string, motivo: string) =>
  api<FichaDoDiario>(`/diarios/${id}/cancelar`,
    { metodo: 'POST', corpo: { motivo } });
